// src/components/AccessCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';

// This card is for each asset in AccessProvider's "assets"
export default function AccessCard({ asset, disableLink = false }) {
  // asset might be { accessKey, assetName, siteName, street_address, city, tasks, etc. }
  const {
    access_key,
    asset_name = 'Unnamed Asset',
    status = 'Available',
    city = '',
    street_address = '',
    tasks = {},
  } = asset;

  // We'll construct the location line
  const locationLine =
    street_address || city
      ? `${street_address} ${city}`.trim()
      : 'Unknown location';

  // For tasks, let's say if tasks has keys => show "X tasks"
  const taskCount = Object.keys(tasks).length;
  const tasksLabel = taskCount > 0 ? `${taskCount} Task(s)` : 'No Tasks';

  return (
    <div className="card mb-3 shadow-sm">
      <div className="card-body d-flex">
        {/* Left side: circle icon + text */}
        <div className="d-flex align-items-start">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{ width: '40px', height: '40px', backgroundColor: '#eef2ff' }}
          >
            <i className="bi bi-lightning-charge-fill text-primary" style={{ fontSize: '1.2rem' }}></i>
          </div>
          <div>
            <div className="fw-bold">{asset_name}</div>
            <small className="text-muted">{status}</small>
            <div className="small text-muted">
              <i className="bi bi-geo-alt-fill me-1"></i>
              {locationLine}
            </div>
            {/* tasks label in orange if tasks >0, else green? */}
            {taskCount > 0 ? (
              <div className="text-warning small mt-1 fw-semibold">
                <i className="bi bi-clock me-1"></i>
                {tasksLabel}
              </div>
            ) : (
              <div className="text-success small mt-1 fw-semibold">
                <i className="bi bi-check-circle me-1"></i>
                {tasksLabel}
              </div>
            )}
          </div>
        </div>
        {/* Right side link */}
        <div className="ms-auto d-flex align-items-start">
          {disableLink ? (
            <span className="text-muted me-1 small">View</span>
          ) : (
            <Link
              to={`/assets/access_key/${access_key}`}
              className="text-decoration-none"
            >
              <span className="text-primary me-1 small">View</span>
              <i className="bi bi-chevron-right text-primary"></i>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
